import React, { useEffect, useCallback } from "react";
import { useAppEventAction } from "src/_common/hooks/actions/event/appEventActionHook";
import { useEventApi } from "src/_common/hooks/actions/event/appEventApiHook";
import { useSocketChannel } from "src/_common/hooks/custom/useSocketChannel";
import { SOCKET_CHANNEL } from "src/_config";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
type SocketData = any;

const SocketImplementations = () => {
  const eventStartDataFromSocket = useSocketChannel<SocketData>(SOCKET_CHANNEL.START_EVENT);
  const performanceStartPickDataFromSocket = useSocketChannel<SocketData>(SOCKET_CHANNEL.PERFORMANCE_START_PICK);
  const performanceEndDataFromSocket = useSocketChannel<SocketData>(SOCKET_CHANNEL.END_ALL_EVENT);
  const winnerDeclaredDataFromSocket = useSocketChannel<SocketData>(SOCKET_CHANNEL.CONTESTANT_WINNER);
  const groupGlowDataFromSocket = useSocketChannel<SocketData>(SOCKET_CHANNEL.GROUP_GLOW);
  const glowEventDataFromSocket = useSocketChannel<SocketData>(SOCKET_CHANNEL.EVENT_GLOW);
  const statusMsgDataFromSocket = useSocketChannel<SocketData>(SOCKET_CHANNEL.STATUS_MSG);
  const startStopRpEventData = useSocketChannel<SocketData>(SOCKET_CHANNEL.START_STOP_RP_EVENT);
  const eventAction = useAppEventAction();
  const eventApi = useEventApi();

  // Memoized empty callbacks for API calls
  const noop = useCallback(() => {
    // intentionally empty
  }, []);

  useEffect(() => {
    if (eventStartDataFromSocket) {
      // console.log({ eventStartDataFromSocket });
      eventAction.eventStatusUpdate(eventStartDataFromSocket);
      eventApi.callGetCategorizedPerformances({}, noop, noop);
      eventApi.callGetActivePerformances({ per_page: 6 }, noop, noop);
    }
  }, [eventStartDataFromSocket, eventAction, eventApi, noop]);

  useEffect(() => {
    if (performanceEndDataFromSocket) {
      // console.log("performanceEndDataFromSocket", performanceEndDataFromSocket);
      eventAction.performanceEndAllEvents(performanceEndDataFromSocket);
    }
  }, [performanceEndDataFromSocket, eventAction]);

  useEffect(() => {
    if (winnerDeclaredDataFromSocket) {
      //console.log("winnerDeclaredDataFromSocket", winnerDeclaredDataFromSocket);
      eventAction.winnerDeclared(winnerDeclaredDataFromSocket);
    }
  }, [winnerDeclaredDataFromSocket, eventAction]);

  useEffect(() => {
    if (performanceStartPickDataFromSocket) {
      // console.log("performanceStartPickDataFromSocket", performanceStartPickDataFromSocket);
      eventAction.performanceStartPick(performanceStartPickDataFromSocket);
    }
  }, [performanceStartPickDataFromSocket, eventAction]);

  useEffect(() => {
    if (groupGlowDataFromSocket) {
      // console.log("groupGlowDataFromSocket", groupGlowDataFromSocket);
      eventAction.groupGlow(groupGlowDataFromSocket);
    }
  }, [groupGlowDataFromSocket, eventAction]);

  useEffect(() => {
    if (glowEventDataFromSocket) {
      eventAction.rodeoEventGlow(glowEventDataFromSocket);
    }
  }, [glowEventDataFromSocket, eventAction]);

  useEffect(() => {
    if (statusMsgDataFromSocket) {
      // console.log("statusMsgDataFromSocket", statusMsgDataFromSocket);
      eventAction.statusMsg(statusMsgDataFromSocket);
    }
  }, [statusMsgDataFromSocket, eventAction]);

  useEffect(() => {
    if (startStopRpEventData) {
      // console.log("startStopRpEventData", startStopRpEventData);
      eventAction.startStopRpEvent(startStopRpEventData);
      eventApi.callGetCategorizedPerformances({}, noop, noop);
      eventApi.callGetActivePerformances({ per_page: 6 }, noop, noop);
    }
  }, [startStopRpEventData, eventAction, eventApi, noop]);

  return <></>;
};

export default SocketImplementations;
